import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })

export class alert {

  public constructor(
    public router: Router,
  ) { }

  responseAlert(text, icon) {
    this.actionResponse(text, icon)
  }

  actionResponse(message, icon) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })

    Toast.fire({
      icon: icon,
      title: message
    })
  }

  
  confirm(options: { title: string, message: string, confirmText: string, cancelText: string }) {
    return Swal.fire({
      title: options.title,
      text: options.message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: options.confirmText,
      cancelButtonText: options.cancelText,
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        return true; 
      } else {
        return false;
      }
    });
  }
}
